export const fontFamily = 'System';

const fontFamilies = {
    regular: { fontWeight: 'normal', fontStyle: 'normal', fontFamily },
    medium: { fontWeight: '500', fontStyle: 'normal', fontFamily },
    bold: { fontWeight: 'bold', fontStyle: 'normal', fontFamily }
};

export default fontFamilies;